import React, { useState, useEffect } from 'react';
import { FiEdit3, FiList, FiUser, FiSend } from 'react-icons/fi';
import Compose from '../../components/admin/emails/Compose';
import Lists from '../../components/admin/emails/Lists';
import Contacts from '../../components/admin/emails/Contacts';
import CampaignHistory from '../../components/admin/emails/CampaignHistory';

const TABS = [
  { id: 'compose', label: 'Compose', icon: FiEdit3 },
  { id: 'lists', label: 'Lists', icon: FiList },
  { id: 'contacts', label: 'Contacts', icon: FiUser },
  { id: 'history', label: 'History', icon: FiSend }
];

const AdminEmails = () => {
  // If StalledSignups (or anything else) dropped a prefill into
  // sessionStorage, jump straight to Compose.
  const [activeTab, setActiveTab] = useState(() => {
    try {
      const raw = sessionStorage.getItem('leavewise.emailCompose.prefill');
      return raw ? 'compose' : 'compose';
    } catch (_) {
      return 'compose';
    }
  });

  // If the user lands here via a "Email them" handoff, stay on compose
  // and let the Compose component pick up the prefill on mount.
  useEffect(() => {
    // no-op — setActiveTab above already covers it; kept for clarity.
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 p-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-4">
          <h1 className="text-xl font-bold text-gray-900 dark:text-white">Emails</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Compose and send messages to users, lists, segments, or ad-hoc addresses.
          </p>
        </div>

        {/* Sub-tabs */}
        <div className="flex gap-0 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md p-1 mb-3 w-fit">
          {TABS.map(t => {
            const Icon = t.icon;
            const active = activeTab === t.id;
            return (
              <button
                key={t.id}
                onClick={() => setActiveTab(t.id)}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-sm font-medium transition-colors ${
                  active
                    ? 'bg-primary-600 text-white'
                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                }`}
              >
                <Icon className="w-4 h-4" />
                {t.label}
              </button>
            );
          })}
        </div>

        {activeTab === 'compose' && <Compose onSent={() => setActiveTab('history')} />}
        {activeTab === 'lists' && <Lists />}
        {activeTab === 'contacts' && <Contacts />}
        {activeTab === 'history' && <CampaignHistory />}
      </div>
    </div>
  );
};

export default AdminEmails;
